<template>

  <b-card class="mt-2 col-12">
    <b-row>
      <b-col class="col-12 text-center">
        <h1>ระบบได้ดำเนินการรับเรื่องร้องทุกข์ สามารถติดตามรายการร้องทุกข์ ตามเลขรับเรื่องนี้</h1>
      </b-col>

      <b-col class="mt-5 col-12  text-center">
        <div v-for="(item, index) in ComplaintList"
          :id="item.complaint.complaintId"
          :key="index">
            <h1 style="text-align:center;">
              {{item.complaint.complaintCode}} - {{item.user.titleStr}} {{item.user.fName}} {{item.user.mName}} {{item.user.lName}}
            </h1>
          </div>
      </b-col>

      <!-- <b-col class="mt-5  col-12 text-center">
        <b-button
          variant="primary"
          @click="myRedirect()"
        >
          <span>แนบหลักฐานประกอบคำร้อง</span>
        </b-button>
      </b-col> -->
    </b-row>

    <ComplaintUpload></ComplaintUpload>

  </b-card>
</template>

<script>
import { BRow, BCol, BButton,BCard, BCardHeader, BCardBody } from 'bootstrap-vue'
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import ComplaintUpload from './complaintUpload.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,BCard, BCardHeader, BCardBody,
    ComplaintAPI,
    ComplaintUpload,
  },
  data() {
    return {
      ComplaintList: [],
      complaintGuid: '',
      parentComponent: '',
    };
  },
  beforeMount() {
    var self = this;
    console.log('self.$route.query.complaintGuid: ',self.$route.query.complaintGuid)
    ComplaintAPI.GetComplaintList(
      self.$route.query.complaintGuid
    )
      .then(function(response) {
        self.ComplaintList = response.data.data;
      })
      .catch(function(error) {
        console.log("error", error);
      })
      .then(function() {});
  },
  methods: {

    myRedirect() {


      this.$router.push({
            name: "servicecentercomplaintUpload",
            query: {
              parentComponent: this.$route.query.parentComponent,
              complaintGuid: this.$route.query.complaintGuid,
              //isGroupGuid: true,
            },
          });
    },
  },
}
</script>

 <style lang="scss" >

</style>
